import { Link } from "react-router-dom";
import { Check, ArrowUpRight } from "lucide-react";
import { APPS } from "../data/apps";
import { Reveal } from "./Shared";
import { AppIcon } from "./AppIcon";

export const AppsGrid = ({ showHeader = true }) => {
  return (
    <section data-testid="apps-grid-section" className="py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        {showHeader && (
          <Reveal>
            <div className="mx-auto max-w-2xl text-center">
              <div className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">5 activités — 1 vision</div>
              <h2 className="mt-4 font-display font-semibold tracking-tight text-navy text-3xl sm:text-4xl lg:text-5xl text-balance">
                Les cinq piliers d'un même groupe, au service de votre quotidien
              </h2>
            </div>
          </Reveal>
        )}

        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {APPS.map((a, i) => {
            const featured = i === 0;
            return (
              <Reveal key={a.slug} i={i}>
                <Link
                  to={`/applications/${a.slug}`}
                  data-testid={`app-card-${a.slug}`}
                  className="group relative flex h-full min-h-[440px] flex-col overflow-hidden rounded-3xl border border-white/10 p-7 shadow-lg transition-all duration-300 hover:-translate-y-1.5 hover:shadow-2xl"
                >
                  {/* Vitrine background photo */}
                  <img
                    src={a.heroImage}
                    alt={`${a.name} — ${a.category}`}
                    className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-navy/78" />
                  <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/70 to-navy/45" />
                  <div
                    className="absolute inset-0"
                    style={{ background: `radial-gradient(120% 80% at 20% 0%, ${a.accent}26 0%, transparent 55%)` }}
                  />

                  {/* Content on top */}
                  <div className="relative z-10 flex h-full flex-col">
                    <div className="flex items-start justify-between">
                      <AppIcon app={a} variant="solid" iconSize={26} containerClass="h-14 w-14 rounded-2xl shadow-lg" />
                      <div className="flex items-center gap-2">
                        {featured && (
                          <span className="rounded-full bg-white/15 px-3 py-1 text-xs font-semibold text-white backdrop-blur-md">
                            Activité principale
                          </span>
                        )}
                        <ArrowUpRight size={20} className="text-white/50 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                      </div>
                    </div>

                    <h3 className="mt-6 font-display font-bold text-xl text-white">{a.name}</h3>
                    <div className="mt-1 text-sm font-semibold" style={{ color: a.accent }}>{a.category}</div>
                    <p className="mt-3 text-sm text-white/70 leading-relaxed">{a.tagline}</p>

                    <ul className="mt-auto space-y-2.5 border-t border-white/10 pt-5">
                      {a.features.slice(0, 4).map((f) => (
                        <li key={f} className="flex items-start gap-2.5 text-sm text-white/85">
                          <Check size={16} className="mt-0.5 shrink-0" style={{ color: a.accent }} />
                          {f}
                        </li>
                      ))}
                    </ul>
                  </div>
                </Link>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
